import * as React from 'react'
import { SVGProps } from 'react'

const SvgLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 137 28' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='m0 18.978 5.327 4.511L0 28v-9.02zm27.995 0-5.327 4.511L27.995 28v-9.02zM0 0v9.022l14 11.845L28 9.022V0L14 11.845 0 0z'
      fill='#3071EE'
    />
    <path d='M0 9.022V0l14 11.845v9.022L0 9.022z' fill='#3071EE' />
    <path d='M28 0v9.022L14 20.867v-9.022L28 0z' fill='#2D54DE' />
    <path d='m0 18.978 5.327 4.511L0 28v-9.02z' fill='#3071EE' />
    <path d='m27.995 18.978-5.327 4.511L27.995 28v-9.02z' fill='#2D54DE' />
    <path
      className='logo-label'
      d='M52.29 5.95h-3.64l-4.322 7.075-4.323-7.075h-3.64v15.925h3.64v-9.26l4.118 6.758h.41l4.117-6.757v9.26h3.64V5.95zm14.226 15.925h3.981L65.083 5.95h-4.641l-5.415 15.925h3.982l.796-2.502h5.915l.796 2.502zm-5.62-5.915 1.866-5.847 1.866 5.847h-3.731zm20.696 5.915h3.913l-3.39-5.847c1.752-.887 2.935-2.661 2.935-4.618a5.447 5.447 0 0 0-5.46-5.46h-6.37v15.925h3.64v-5.232h1.73l3.002 5.232zM76.86 9.363h2.73c1.001 0 1.82.887 1.82 2.047 0 1.16-.819 2.048-1.82 2.048h-2.73V9.363zm27.265 3.64H96.14v3.185h4.254c-.568 1.524-1.956 2.457-4.072 2.457-3.094 0-5.005-1.98-5.005-4.687 0-2.798 2.002-4.777 4.687-4.777 1.797 0 3.23.819 3.89 1.865l3.094-1.774c-1.342-2.139-3.913-3.64-6.962-3.64-4.686 0-8.349 3.685-8.349 8.303 0 4.573 3.595 8.259 8.6 8.259 4.459 0 7.848-2.958 7.848-7.826v-1.365zm7.058 5.369V15.55h5.687v-3.458h-5.687v-2.64h6.256V5.95h-9.896v15.925h10.01v-3.503h-6.37zm22.301 3.503-4.755-8.167 4.527-7.758h-4.14l-2.457 4.209-2.457-4.209h-4.141l4.528 7.758-4.755 8.167h4.14l2.685-4.595 2.684 4.595h4.141z'
    />
  </svg>
)

export default SvgLogoIcon
